import { loadImage } from './loadImage';

export const uploadFileToUrl = async (file: File, url: string) => {
  const res = await fetch(url, {
    method: 'PUT',
    body: file,
    headers: {
      'Content-Type': file.type,
    },
  });

  if (!res.ok) throw new Error(`Error ${res.status} (${res.statusText})`);

  return res;
};

export const isImageFile = (file: File) => file.type.includes('image');
export const isVideoFile = (file: File) => file.type.includes('video');

export const fileExceedSizeInMo = (file: File, sizeInMo: number) =>
  file.size > sizeInMo * 1024 * 1024;

export const imageHasMinDimensions = async (
  file: File,
  minWidth: number,
  minHeight: number,
) => {
  if (!isImageFile(file)) {
    throw new Error('imageHasMinDimensions failed (file is not an image)');
  }
  const image = await loadImage(window.URL.createObjectURL(file));
  return image.width >= minWidth && image.height >= minHeight;
};
